import { Box, BoxProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export type TabLinkListProps = BoxProps;

export const TabLinkList: React.FC<TabLinkListProps> = ({
  children,
  ...props
}) => {
  return (
    <Box display="flex" flexWrap="wrap" {...props}>
      {children}
    </Box>
  );
};

export const TabLink: React.FC<
  BoxProps & {
    href: string;
    matchHref?: string;
    isExact?: boolean;
  }
> = ({ href, matchHref, isExact, children, ...props }) => {
  const isRouteMatch = useRouteMatch(matchHref ?? href, { isExact });

  return (
    <NextLink href={href}>
      <Box
        display="inline-block"
        fontSize="md"
        fontWeight={isRouteMatch ? 'semibold' : 'normal'}
        borderBottom="2px"
        borderColor={isRouteMatch ? 'primary.500' : 'transparent'}
        p="4"
        color={isRouteMatch ? 'gray.800' : 'gray.600'}
        {...props}
      >
        {children}
      </Box>
    </NextLink>
  );
};
